import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { FEATURE_FLAGS } from '../../config/featureFlags';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.section}>
            <h4 className={styles.sectionTitle}>About Novara</h4>
            <p className={styles.description}>
              Explore what humans truly need to learn. Our platform combines
              adaptive testing, knowledge sharing, and community engagement to
              help you discover and develop future-critical skills and concepts.
            </p>
          </div>

          <div className={styles.section}>
            <h4 className={styles.sectionTitle}>Quick Links</h4>
            <ul className={styles.linkList}>
              <li>
                <Link to="/test">Take a Test</Link>
              </li>
              {/* New Words / Challenges — hidden from MVP (KAN-130) */}
              {FEATURE_FLAGS.NEW_WORDS && (
                <li>
                  <Link to="/new-word-prize">New Words</Link>
                </li>
              )}
              {FEATURE_FLAGS.CHALLENGE_SUBMISSION && (
                <li>
                  <Link to="/thought-challenge">Challenges</Link>
                </li>
              )}
              <li>
                <Link to="/leaderboards">Leaderboards</Link>
              </li>
            </ul>
          </div>

          <div className={styles.section}>
            <h4 className={styles.sectionTitle}>Contact</h4>
            <ul className={styles.linkList}>
              <li>
                <a href="mailto:contact@novara.tech">
                  contact@novara.tech
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/novara-capability-network/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            &copy; {currentYear} Novara. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
